import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'tetrapli';
const args = {};

export class Tetrapli extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
